import { render } from "./AuthLayout.vue?vue&type=template&id=8a451e26"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=8a451e26&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/layout/AuthLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a451e26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a451e26', __exports__)) {
    api.reload('8a451e26', __exports__)
  }
  
  module.hot.accept("./AuthLayout.vue?vue&type=template&id=8a451e26", () => {
    api.rerender('8a451e26', render)
  })

}


export default __exports__